<template>
  <div
    id="infoBox"
    ref="infoBox"
    :class="{ 'in-active': !active }"
    :style="{ height: height }"
    class="info-box">
    <div
      class="header"
      @click="toggleContent">
      {{ title }}
      <div
        :class="{ active: active }"
        class="arrow">
        <close-icon />
      </div>
    </div>
    <div
      class="content"
      v-html="text" />
  </div>
</template>
<script>

import CloseIcon from './icons/CloseIcon'
import { trackCollapsable } from '../utils/track.js'

export default {
  components: {
    CloseIcon
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      active: true,
      height: '',
      windowWidth: 0
    }
  },
  mounted () {
    this.boxHeight()
    this.active = false
  },
  methods: {
    toggleContent () {
      this.active = !this.active
      trackCollapsable('echolocatie', this.active)
    },
    boxHeight () {
      this.height = `${this.$refs.infoBox.clientHeight}px`
    }
  }
}
</script>
<style lang="scss" scoped>

  $header-height: 36px;

  .info-box {
    width: 100%;
    margin: 25px auto 20px;
    border-radius: 15px;
    overflow: hidden;
    transition: all 0.3s ease;

    &.in-active {
      height: $header-height !important;
      .header {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }
    }

    @include bigmobile {
      width: 80%;
    }

    .arrow {
      width: 10px;
      position: absolute;
      right: 18px;
      top: 4px;
      display: flex;
      transition: all .3s ease;
      transform-origin: 50% 50%;
      transform: rotate(45deg);

      &.active {
        transform: rotate(90deg);
      }

    }
  }
  .header {
    position: relative;
    background-color: #ff6666;
    height: $header-height;
    display: flex;
    align-items: center;
    padding: 0 20px;
    color: #fff;
    font-weight: bold;
    cursor: pointer;
  }
  .content {
    width: 100%;
    font-size: 17px;
    line-height: 1.6;
    background-color: #ff6666;
    color: #fff;
    padding: 0 20px 20px;
  }

</style>



// WEBPACK FOOTER //
// src/components/CollapsableBox.vue